import merge from 'lodash/merge';

import { catalystThemeTwo } from '../../../components/_ThemeTwo_';

import { defaultDatePicker, defaultModal, IThemeInterface } from './common';

const colorBrandPrimary: string = '#214948';
const colorBrandPrimarySoft: string = '';
const colorBrandSecondary: string = '';
const colorBrandTertiary: string = '';
const colorBrandWarning: string = '#FFC107';
const colorBannerAlert: string = '#D10026';
const colorBannerSuccess: string = '#00854B';
const colorBrandLink: string = '#0053A4';
const colorBrandLinkHover: string = '';
const colorBannerWarning: string = '';

const colorButtonDisabled: string = '';

const colorButtonPrimary: string = '';
const colorBrandAlert: string = '';

const colorSlate: string = '';
const colorSlate5: string = '';
const colorSlate10: string = '';
const colorSlate50: string = '';
const colorSlate70: string = '';
const colorBrandText: string = '';
const colorWhite: string = '#fff';

const catalystTheme: IThemeInterface = {
  name: 'catalyst',
  outline: '3px solid #3898EC',
  globalAnchorDecoration: '',
  colorBackground: colorWhite,
  colorLineHeight: '',
  workflowLinkTextDecoration: '',

  colorWhite,
  colorSlate5,
  colorSlate10,
  colorSlate20: '',
  colorSlate50,
  colorSlate70,
  colorSlate,
  colorBlack: '',
  colorStatusWarning: '',

  actionButton: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorTextActive: colorWhite,
    colorBorder: colorSlate10,
    colorBorderHover: colorButtonPrimary,
    colorBackgroundActive: colorButtonPrimary,
  },
  alert: {
    borderWidth: '1px',
    alert: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandAlert,
    },
    success: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    primary: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    secondary: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandWarning,
    },
    inactive: {
      colorBackground: colorSlate5,
      colorText: colorBrandText,
      colorBorder: colorSlate5,
    },
    default: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
  },
  banner: {
    alert: {
      colorBorder: colorBannerAlert,
      colorBackground: colorBannerAlert,
      colorText: colorBrandText,
      colorLink: colorBrandText,
      colorBorderLeft: colorBrandAlert
    },
    success: {
      colorBorder: colorBrandTertiary,
      colorBackground: colorBrandTertiary,
      colorText: colorBrandText,
      colorLink: colorBrandText,
      colorBorderLeft: colorBannerSuccess
    },
    primary: {
      colorBorder: colorBrandPrimarySoft,
      colorBorderLeft: colorBrandPrimary,
      colorBackground: colorBrandPrimarySoft,
      colorText: colorBrandText,
      colorLink: colorBrandText,
    },
    secondary: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorBrandText,
      colorLink: colorBrandText,
    },
    warning: {
      colorBorder: colorBannerWarning,
      colorBackground: colorBannerWarning,
      colorText: colorBrandText,
      colorLink: colorBrandText,
      colorBorderLeft: '6'
    },
    inactive: {
      colorBorder: colorSlate5,
      colorBackground: colorSlate5,
      colorText: colorSlate,
      colorLink: colorSlate,
    },
    default: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorSlate,
      colorLink: colorSlate,
    },
    linkTextWeight: '500',
    sectionBackground: colorSlate10,
    paddingBanner: '1.283em',
    fontSizeBannerText: '1.6rem',
    fontWeightBanner: '500',
  },
  bannerSection: {
    colorBackground: colorSlate,
  },
  brand: {
    colorPrimary: colorBrandPrimary,
    colorPrimarySoft: colorBrandPrimarySoft,
    colorSecondary: colorBrandSecondary,
    colorWarning: colorBrandWarning,
    colorAlert: colorBrandAlert,
  },
  button: {
    primary: {
      boxShadow: 'none',
      padding: '0.5em 1.25em',
      colorBackground: colorButtonPrimary,
      colorBackgroundHover: colorBrandLinkHover,
      colorBackgroundFocus: colorBrandLinkHover,
      colorBorder: colorButtonPrimary,
      colorBorderHover: colorBrandLinkHover,
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: colorSlate50,
      loadingIconInsideButton: true,
      spinner: {
        size: '24px',
        color: {
          circleOutline: 'white',
        },
      },
    },
    secondary: {
      boxShadow: 'none',
      padding: '0.5em 1.25em',
      colorBackground: colorBrandSecondary,
      colorBackgroundHover: '',
      colorBackgroundFocus: '',
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorder: colorBrandSecondary,
      colorBorderHover: colorBrandSecondary,
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: colorSlate50,
      loadingIconInsideButton: true,
      spinner: {
        size: '24px',
        color: {
          circleOutline: 'white',
        },
      },
    },
    alert: {
      boxShadow: 'none',
      padding: '0.5em 1.25em',
      colorBackground: '',
      colorBackgroundHover: '',
      colorBackgroundFocus: '',
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorder: '',
      colorBorderHover: '',
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: colorSlate50,
      loadingIconInsideButton: true,
      spinner: {
        size: '24px',
        color: {
          circleOutline: 'white',
        },
      },
    },

    letterSpacing: 'normal',
    focusBoxShadow: `inset 0 0 0 1px ${colorWhite}`,
    fontWeight: '500',
    fontSize: '2rem',
    textTransform: 'none',
    borderRadius: '6px',
    borderWidth: '2px',
    tinySize: '1.2rem',
    tinyPadding: '0.5em 2em',
    baseButtonMinWidth: '8.8em',
  },
  card: {
    borderRadius: '4px',
    borderWidth: '1px',
    colorBorder: colorSlate10,
    colorBackground: colorWhite,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
  },
  checkbox: {
    colorBorder: colorSlate,
    colorBackground: colorWhite,
    colorBackgroundChecked: colorBrandPrimary,
    colorBackgroundAlert: colorWhite,
    fontSize: '1.6rem',
    error: {
      border: { color: 'error' },
    },
  },
  datepicker: merge({}, defaultDatePicker, {
    input: {
      // tslint:disable:max-line-length
      icon: "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.6546 15.9163L11.7061 15.9524C11.8761 16.0719 12.1063 16.0575 12.2601 15.9178L19.8586 8.89952C20.0466 8.72585 20.0729 8.43801 19.9198 8.2329C19.7417 7.99428 19.3956 7.96303 19.1778 8.16618L11.9969 14.8666L4.82001 8.16607C4.60303 7.9635 4.25732 7.99485 4.07857 8.23184C3.92446 8.43616 3.94867 8.72499 4.13577 8.8996L11.6546 15.9163Z' fill='%238D8D8D'/%3E%3C/svg%3E%0A",
      valueFormat: 'MM/DD/YYYY'
    },
    navButton: {
      color: colorBrandPrimary,
      // tslint:disable:max-line-length
      nextIcon: (color: string) => `"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.9473 12.1914C20.9229 12.2504 20.8867 12.3056 20.8388 12.3536L13.0606 20.1317C12.8653 20.327 12.5487 20.327 12.3535 20.1317C12.1582 19.9365 12.1582 19.6199 12.3535 19.4246L19.2781 12.5L3.51465 12.5C3.23851 12.5 3.01465 12.2761 3.01465 12C3.01465 11.7239 3.23851 11.5 3.51465 11.5L19.2781 11.5L12.3535 4.57539C12.1582 4.38012 12.1582 4.06354 12.3535 3.86828C12.5487 3.67302 12.8653 3.67302 13.0606 3.86828L20.8388 11.6465C20.8867 11.6944 20.9229 11.7496 20.9473 11.8086C20.9695 11.8622 20.9819 11.9189 20.9846 11.976C20.985 11.984 20.9852 11.992 20.9852 12C20.9852 12.0678 20.9717 12.1324 20.9473 12.1914Z' fill='${encodeURIComponent(color)}' fillRule='nonzero' /%3E%3C/svg%3E"`,

      prevIcon: (color: string) => `"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.05273 12.1914C3.07713 12.2504 3.1133 12.3056 3.16124 12.3536L10.9394 20.1317C11.1347 20.327 11.4513 20.327 11.6465 20.1317C11.8418 19.9365 11.8418 19.6199 11.6465 19.4246L4.7219 12.5L20.4854 12.5C20.7615 12.5 20.9854 12.2761 20.9854 12C20.9854 11.7239 20.7615 11.5 20.4854 11.5L4.7219 11.5L11.6465 4.57539C11.8418 4.38012 11.8418 4.06354 11.6465 3.86828C11.4513 3.67302 11.1347 3.67302 10.9394 3.86828L3.16124 11.6465C3.1133 11.6944 3.07713 11.7496 3.05273 11.8086C3.03054 11.8622 3.01809 11.9189 3.01536 11.976C3.01498 11.984 3.01479 11.992 3.01479 12C3.01479 12.0678 3.02828 12.1324 3.05273 12.1914Z' fill='${encodeURIComponent(color)}' fillRule='nonzero' /%3E%3C/svg%3E"`,
      // tslint:enable:max-line-length
      backgroundSize: '100%'
    },
    month: {
      fontSize: 'body'
    },
    weekday: {
      color: colorBrandText,
      fontSize: 'bodyMedium',
      fontWeight: '700',
      border: { side: 'bottom', color: colorButtonDisabled }
    },
    day: {
      hover: {
        backgroundColor: colorBrandPrimary,
        color: colorWhite
      },
      fontSize: 'bodyMedium',
      padding: {top: '.5em', right: '.7em', left: '.7em', bottom: '1.5em'},
      border: { side: 'bottom', color: colorButtonDisabled },
      leadingZero: true
    },
    selection: {
      borderRadius: '0',
      color: colorWhite,
      backgroundColor: colorBrandPrimary,
    },
    overlay: {
      borderRadius: '0'
    },
    dayPickerProps: {
      months: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },
  }),
  header: {
    colorBreadcrumbText: colorBrandText,
    colorHeaderDrawerLinkAboveSmallBP: colorBrandLink,
    colorLink: colorBrandText,
    colorLinkHover: colorBrandLink,
    colorSubNavLink: colorBrandText,
    colorSubNavLinkHover: colorBrandLinkHover,
    subNavBreakPoint: 'large',
    summaryWeight: '700',
    breadcrumbIcon: {
      color: colorBrandText,
      size: '16px',
      transform: 'translateY(2px)',
      margin: { right: '1x' },
    },
    collapsibleSubNav: {
      height: '3.5em'
    },
    headerSubNav: {
      border: { side: 'bottom', color: 'gray300', }
    },
  },
  headline: {
    small: {
      size: '1.6rem',
      sizeResponsive: '1.6rem',
      lineHeightResponsive: '1.2',
      lineHeight: '1.2',
      letterSpacing: 'normal',
      weight: '400',
      colorText: colorBrandText,
      displayTypeface: 'optimist_light',
    },
    medium: {
      size: '2.4rem',
      sizeResponsive: '2.4rem',
      lineHeight: '1.2',
      lineHeightResponsive: '1.2',
      letterSpacing: 'normal',
      weight: '400',
      colorText: colorBrandText,
      displayTypeface: 'optimist_light',
    },
    large: {
      size: '3.6rem',
      sizeResponsive: '2.4rem',
      lineHeight: '1.25',
      lineHeightResponsive: '1.4',
      letterSpacing: 'normal',
      weight: '400',
      colorText: colorBrandText,
      displayTypeface: 'optimist_light',
    },
  },
  icon: {
    brandText: {
      colorIcon: colorBrandText,
    },
    brand: {
      colorIcon: colorBrandPrimary,
    },
    link: {
      colorIcon: colorBrandPrimary,
    },
    grey: {
      colorIcon: colorSlate10,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
    },
    tertiary: {
      colorIcon: colorWhite,
    },
    error: {
      colorIcon: colorBrandWarning,
    },
  },
  input: {
    boxShadowHover: `inset 0 0 0 1px ${colorBrandPrimary}`,
    boxShadowAlert: `${colorBrandAlert} 0px 0px 0px 1px inset`,
    colorBorder: colorSlate,
    colorBackground: colorWhite,
    colorPlaceholder: '',
    colorFocus: colorBrandPrimary,
    colorTextAreaBorder: colorSlate50,
    colorTextAreaBackground: colorWhite,
    borderRadius: '4px',
    borderWidth: '1px',
    padding: '0.75em',
    selectInputBackgroundSvgFocused: '',
    textAreaPadding: '0.75em',
  },
  label: {
    datapointWeight: '400',
    formLabelColor: colorBrandText,
    formLabelMargin: '0.5em',
    formLabelWeight: '500',
    smallTypeWeight: '700',
    fontWeight: '500',
    size: '1.4rem',
    spacing: 'normal',
    textTransform: 'none',
    cardLabelSize: '2rem',
  },
  link: {
    colorLink: colorBrandLink,
    colorLinkIcon: colorBrandPrimary,
    colorLinkHover: colorBrandLinkHover,
  },
  modal: {
    ...defaultModal,
    colorText: colorBrandText,
    colorHeadlineText: colorBrandText,
    colorDrawerBorder: colorSlate10,
    colorDrawerHover: colorBrandText,
    colorDrawerBackgroundHover: colorSlate10,
    colorBoxShadow: '0 3px 20px 8px rgba(0, 0, 0, 0.1)',
    colorBackground: 'rgba(20,20,20,0.9)',
    colorClose: colorBrandText,
    borderRadius: '4px',
    mobilePadding: '2em 2em',
    mobileColorBackground: 'rgba(20,20,20,0.9)',
    closePadding: '1.5em',
    closeSize: '0.875em',
    mobileCloseSize: '0.875em',
    padding: '2em 2em'
  },
  notification: {
    success: {
      colorBorder: colorBrandSecondary,
    },
    error: {
      colorBorder: colorBrandWarning,
    },
    info: {
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBorder: colorBrandWarning,
    },
    widthBorder: '0.5em',
    spacing: '1em',
    colorHover: colorBrandPrimary,
  },
  pill: {
    alert: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    success: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    primary: {
      colorBackground: colorWhite,
      colorText: colorBrandPrimary,
    },
    secondary: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    warning: {
      colorBackground: colorWhite,
      colorText: colorBrandWarning,
    },
    inactive: {
      colorBackground: colorWhite,
      colorText: colorSlate50,
    },
    default: {
      colorBackground: colorWhite,
      colorText: colorBrandPrimary,
    },
    letterSpacing: 'normal',
    padding: '0 0.75em',
    borderRadius: '2px',
    textTransform: 'capitalize',
    fontSize: '1.6rem',
  },
  progress: {
    colorBar: colorButtonPrimary,
    colorCircularBackground: colorSlate10,
    colorBarBackground: 'transparent',
    colorBarBorder: colorButtonPrimary,
    circularWeight: '700',
    circularSize: '3.6rem',
  },
  progressTracker: {
    colorCompleted: colorBrandPrimary,
    colorOutstanding: colorSlate10,
    colorProgressTrackerBackground: '',
    colorTextOutstanding: colorBrandText,
    colorTextCompleted: colorBrandText,
    colorStepBgCompleted: colorBrandTertiary,
    colorStepBorderCompleted: colorBrandTertiary,
    colorStepBgOutstanding: colorSlate5,
    colorStepBorderOutstanding: colorSlate5,
    colorHrOutstanding: colorSlate10,
    colorHrCompleted: colorBrandTertiary,
    headerContainerPadding: '0.75em 0',
    hrHorizontalOffset: '16px',
    hrVerticalOffset: '-27px',
    hrWidth: '96.4px',
    iconCheckedDone: 'done',
    stepLabelFontWeight: '400',
    stepLabelHorizontalOffset: '0.5em',
    stepNumberFontWeight: '700',
    stepNumberFontSize: '1.6rem',
    stepNumberVerticalOffset: '2px',
    svgCompletedHeight: '17.5px',
    svgCompletedWidth: '17.5px',
    trackerIndicatorWidth: '34px',
    trackerIndicatorHeight: '34px',
    trackerWrapperWidth: '162px',
  },
  radio: {
    boxShadow: colorBrandPrimary,
    boxShadowHover: colorBrandPrimary,
    colorBorder: colorSlate,
    colorBorderHover: colorBrandPrimary,
    colorBorderChecked: colorBrandPrimary,
    colorBackground: colorWhite,
    colorBackgroundHover: colorWhite,
    colorBackgroundChecked: colorBrandPrimary,
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorTextChecked: colorWhite,
    colorTextAlert: colorBrandAlert,
    padding: '0.6em 0.75em',
    borderWidth: '2px',
    fontWeight: '500',
  },
  radioCard: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorBackgroundChecked: '',
  },
  radioInput: {
    borderWidth: '1px',
    borderWidthActive: '1px',
    hasActiveHeightAndWidth: false,
    colorBackground: colorWhite,
    colorInner: colorWhite,
    colorBorder: colorBrandPrimary,
    colorBorderInactive: colorSlate,
    colorRadioLabelBackground: colorWhite,
    colorRadioLabelBackgroundActive: colorBrandPrimary,
    colorRadioButtonHover: colorBrandLinkHover,
    sizeRadioButton: '1.375em',
    sizeRadioButtonHover: 'calc(1.375em - 2px)',
    sizeRadioButtonInnerMark: '8px',
    positionRadioButtonInnerMarkTop: '0.625em',
    positionRadioButtonInnerMarkLeft: '0.625em',
    labelTextOffset: '0.75em',
    error: {
      border: { color: colorSlate, size: 'single' }
    }
  },
  spinner: {
    colorBackground: colorSlate10,
    colorSegment: colorBrandPrimary,
  },
  table: {
    alert: {
      colorIcon: colorBrandAlert,
      colorText: colorBrandAlert,
    },
    success: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandSecondary,
    },
    primary: {
      colorIcon: colorBrandPrimary,
      colorText: colorBrandText,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandText,
    },
    warning: {
      colorIcon: colorBrandWarning,
      colorText: colorBrandText,
    },
    inactive: {
      colorIcon: colorSlate50,
      colorText: colorSlate50,
    },
    default: {
      colorIcon: colorSlate70,
      colorText: colorBrandText,
    },
    filter: {
      colorText: colorBrandText,
      colorTextSelected: colorBrandPrimary,
      colorBackground: '',
      borderRadius: '4px',
    },
    header: {
      colorBackground: colorSlate5,
      colorSubHeaderBackground: '',
      fontWeight: '700',
    },
    colorDetailsButton: colorBrandPrimary,
    colorDivider: colorSlate10,
  },
  taskCard: {
    colorBorder: 'none',
    colorText: colorBrandText,
    colorIcon: 'red',
    colorCtaIcon: colorBrandPrimary,
    colorSubhead: colorSlate,
    colorInReviewBorder: 'none',
    colorCompleteText: colorBrandText,
    fontWeightHeadline: '500',
    fontWeightSubHead: '500',
    hasIcon: false,
  },
  text: {
    colorBullet: colorBrandPrimary,
    colorText: colorBrandText,
    colorCaption: colorBrandText,
  },
  toolTip: {
    fontColor: colorWhite,
    paneFontSize: '1.6rem',
    paneBackgroundColor: colorBrandText,
    paneBoxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    paneBorderRadius: '2px',
  },
  typography: {
    bodyTypeface: 'inter_regular',
    displayTypeface: 'inter_regular',
  },
  upload: {
    colorBackground: colorWhite,
    colorBorder: '',
    colorActiveBackground: '',
    colorActiveBorder: '',
    colorText: '',
    borderStyle: 'dashed',
    borderWidth: '2px',
    size: '16em',
  },
  verifications: {
    mastHeadlineColor: colorBrandText,
  },
  // themeTwo should be removed once themeTwo replaces current theme
  themeTwo: { ...catalystThemeTwo },
};

export default catalystTheme;
